export default class LocationEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#location_uuid") ? (elem.querySelector("#location_uuid") as HTMLInputElement).value : null,
            name: elem.querySelector("#location_name").value
        }
    }
}